(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clz-ajax-cart"]) return;
  try {
    
(function(){
  var CLASS_BUY = '.clz-pd__buynow, [data-clz-buynow], [data-clz-buy]';
  var MOBILE = '(max-width: 749px)';
  var BUSY = 'Opening\u2026';
  var SNAP = 'clzBuyNowSnap';

  function isMobile(){ return window.matchMedia(MOBILE).matches; }

  function drawerEl(){ return document.getElementById('cart-drawer'); }
  function drawerTrigger(){
    return document.querySelector('.header__cart-link a[aria-controls="cart-drawer"]')
        || document.querySelector('[aria-controls="cart-drawer"]');
  }
  function isDrawerOpen(){
    var d = drawerEl();
    return !!d && (d.hasAttribute('open') || d.classList.contains('is-open') || d.getAttribute('aria-hidden') === 'false');
  }
  function openDrawer(){ if(!isDrawerOpen()){ var t = drawerTrigger(); if(t) t.click(); } }
  function notify(){
    ['cart:refresh','cart:update','cart:change'].forEach(function(ev){
      document.dispatchEvent(new CustomEvent(ev, { bubbles:true }));
    });
  }

  /* ---------- the shopper's actual selection ---------- */

  function sourceVariantInput(){
    return document.querySelector('[data-clz-vid]')
        || document.querySelector('.clz-pd__form [name="id"]')
        || document.querySelector('form[action*="/cart/add"]:not(#clz-dyn-form) [name="id"]');
  }
  function sourceQtyInput(){
    return document.querySelector('[data-clz-qty]')
        || document.querySelector('.clz-pd__form [name="quantity"]')
        || document.querySelector('form[action*="/cart/add"]:not(#clz-dyn-form) [name="quantity"]');
  }
  /* The selected size button is the final authority if the input lags. */
  function selectedSizeId(){
    var on = document.querySelector('.clz-pd__sz.is-on[data-clz-v]');
    return on ? on.getAttribute('data-clz-v') : null;
  }

  /* ---------- record / restore the cart around Buy now ---------- */

  function snapshotCart(){
    return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var items = (cart.items || []).map(function(i){
          return { id: i.variant_id, quantity: i.quantity };
        });
        try { sessionStorage.setItem(SNAP, JSON.stringify(items)); } catch(e){}
      })
      .catch(function(){});
  }

  function restoreSnapshot(){
    var raw = null;
    try { raw = sessionStorage.getItem(SNAP); } catch(e){ return; }
    if(raw === null) return;
    try { sessionStorage.removeItem(SNAP); } catch(e){}

    var p = window.location.pathname;
    if(p.indexOf('/checkouts') === 0 || p.indexOf('/orders') === 0 || p.indexOf('thank') > -1) return;

    var items;
    try { items = JSON.parse(raw) || []; } catch(e){ return; }

    fetch('/cart/clear.js', { method:'POST', headers:{ 'Accept':'application/json' } })
      .then(function(){
        if(!items.length) return null;
        return fetch('/cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function(){ notify(); })
      .catch(function(){});
  }

  if(document.readyState !== 'loading'){ restoreSnapshot(); }
  else { document.addEventListener('DOMContentLoaded', restoreSnapshot); }
  window.addEventListener('pageshow', function(e){ if(e.persisted) restoreSnapshot(); });

  /* ---------- which Buy it now is visible ---------- */

  function inStickyBar(el){
    var n = el;
    while(n && n !== document.body){
      var pos = getComputedStyle(n).position;
      if(pos === 'fixed' || pos === 'sticky') return true;
      n = n.parentElement;
    }
    return false;
  }

  function looksLikeBuyNow(el){
    var t = (el.textContent || '').trim().toLowerCase();
    if(!t || t.length > 24) return false;
    return t.indexOf('buy it now') > -1 || t.indexOf('buy now') > -1;
  }

  function buyButtons(){
    var found = [];
    function add(el){
      if(!el || found.indexOf(el) > -1) return;
      if(el.closest('.clz-rm') || el.closest('#clz-dyn-form') || el.closest('#cart-drawer')) return;
      found.push(el);
    }
    document.querySelectorAll(CLASS_BUY).forEach(add);
    document.querySelectorAll('button, a, [role="button"]').forEach(function(el){
      if(looksLikeBuyNow(el)) add(el);
    });
    return found.filter(function(el){
      return !found.some(function(o){ return o !== el && el.contains(o); });
    });
  }

  function applyVisibility(){
    var all = buyButtons();
    if(!all.length) return;

    if(!isMobile()){
      all.forEach(function(b){ b.style.removeProperty('display'); });
      return;
    }
    var keep = null;
    for(var i = 0; i < all.length; i++){ if(inStickyBar(all[i])){ keep = all[i]; break; } }
    if(!keep) keep = all[all.length - 1];

    all.forEach(function(b){
      if(b === keep) b.style.removeProperty('display');
      else b.style.setProperty('display', 'none', 'important');
    });
  }

  if(document.readyState !== 'loading'){ applyVisibility(); }
  else { document.addEventListener('DOMContentLoaded', applyVisibility); }
  setTimeout(applyVisibility, 400);
  setTimeout(applyVisibility, 1200);
  setTimeout(applyVisibility, 2500);

  try {
    var mq = window.matchMedia(MOBILE);
    if(mq.addEventListener) mq.addEventListener('change', applyVisibility);
    else if(mq.addListener) mq.addListener(applyVisibility);
  } catch(e){}

  function dynButton(){
    var f = document.getElementById('clz-dyn-form');
    if(!f) return null;
    return f.querySelector('.shopify-payment-button__button')
        || f.querySelector('shopify-accelerated-checkout button')
        || f.querySelector('button');
  }

  document.addEventListener('click', function(e){

    /* ---------- BUY NOW ---------- */
    var buy = e.target.closest(CLASS_BUY);
    if(!buy){
      var cand = e.target.closest('button, a, [role="button"]');
      if(cand && looksLikeBuyNow(cand) && !cand.closest('#clz-dyn-form') && !cand.closest('.clz-rm') && !cand.closest('#cart-drawer')){
        buy = cand;
      }
    }

    if(buy && !buy.disabled && !buy.classList.contains('clz-buy-loading')){
      e.preventDefault();
      e.stopPropagation();

      var vid = sourceVariantInput();
      var qin = sourceQtyInput();
      var id  = selectedSizeId() || (vid ? vid.value : null);
      var qty = qin ? (parseInt(qin.value, 10) || 1) : 1;

      if(!id){
        var was = buy.textContent;
        buy.textContent = 'Pick a size first';
        setTimeout(function(){ buy.textContent = was; }, 1800);
        return;
      }

      var dId = document.getElementById('clz-dyn-id');
      var dQ  = document.getElementById('clz-dyn-qty');
      if(dId) dId.value = id;
      if(dQ)  dQ.value  = qty;

      if(!buy.getAttribute('data-clz-label')) buy.setAttribute('data-clz-label', buy.textContent);
      buy.textContent = BUSY;
      buy.classList.add('clz-buy-loading');

      snapshotCart().then(function(){
        var dyn = dynButton();
        if(dyn){ dyn.click(); }
        else { window.location.href = '/checkout'; }
      });

      setTimeout(function(){
        var prev = buy.getAttribute('data-clz-label');
        if(prev){ buy.textContent = prev; buy.removeAttribute('data-clz-label'); }
        buy.classList.remove('clz-buy-loading');
      }, 6000);
      return;
    }

    /* ---------- ADD TO BAG ---------- */
    var add = e.target.closest('[data-clz-addbtn]');
    if(add && !add.disabled){
      e.preventDefault();
      e.stopPropagation();

      var f = add.closest('form');
      if(!f) return;

      try { sessionStorage.removeItem(SNAP); } catch(err){}

      var label = add.textContent;
      add.disabled = true;
      add.classList.add('is-busy');
      add.textContent = 'Adding\u2026';

      fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' },
        body: new FormData(f)
      })
      .then(function(r){
        if(!r.ok){ return r.json().then(function(err){ throw new Error((err && err.description) || 'Could not add'); }); }
        return r.json();
      })
      .then(function(){
        notify();
        openDrawer();
        add.disabled = false;
        add.classList.remove('is-busy');
        add.textContent = label || 'Add to bag';
      })
      .catch(function(err){
        add.disabled = false;
        add.classList.remove('is-busy');
        add.textContent = (err && err.message) ? err.message : 'Try again';
        setTimeout(function(){ add.textContent = label || 'Add to bag'; }, 2200);
      });
    }
  }, true);

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.querySelector) return;
    if(form.id === 'clz-dyn-form') return;
    if(!form.querySelector('[data-clz-addbtn]')) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-cart-extras"]) return;
  try {
    
(function(){
  function cfg(){
    var el = document.querySelector('.clz-cx-cfg');
    return {
      hide: ((el && el.dataset.hide) || 'order note,estimate shipping').split(',').map(function(s){ return s.trim().toLowerCase(); }).filter(Boolean),
      label: (el && el.dataset.label) || 'Discount'
    };
  }

  function money(cents){
    var v = (cents || 0) / 100;
    try {
      return '\u20B9' + v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch(e){ return '\u20B9' + v.toFixed(2); }
  }

  var DISCOUNT_RE = /\d+%\s*off|get\s+\d+%/i;

  function hideExtras(root){
    var c = cfg();
    root.querySelectorAll('button, summary, a, label, span, div').forEach(function(el){
      if(el.dataset.clzHidden) return;
      if(el.closest('.clz-co') || el.closest('.clz-disc')) return;
      if(el.children.length > 2) return;
      var t = (el.textContent || '').trim().toLowerCase();

      /* named rows */
      if(c.hide.indexOf(t) !== -1){
        var target = el.closest('details') || el;
        target.style.display = 'none';
        target.dataset.clzHidden = '1';
        return;
      }

      /* theme's own discount chip — we render our own row */
      if(el.children.length === 0 && DISCOUNT_RE.test(t) && t.length < 60){
        var chip = el.parentElement && el.parentElement.children.length <= 2 ? el.parentElement : el;
        chip.style.display = 'none';
        chip.dataset.clzHidden = '1';
      }
    });
  }

  function findTotalRow(root){
    var leaf = null;
    root.querySelectorAll('*').forEach(function(el){
      if(el.children.length) return;
      if((el.textContent || '').trim().toLowerCase() === 'total'){ leaf = el; }
    });
    return leaf ? (leaf.parentElement || null) : null;
  }

  function renderDiscount(root, cart){
    var existing = root.querySelector('.clz-disc');
    if(existing) existing.remove();
    var amount = cart.total_discount || 0;
    if(amount <= 0) return;

    var c = cfg();
    var row = document.createElement('div');
    row.className = 'clz-disc';
    row.innerHTML =
      '<span class="clz-disc__l">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 2.5 21.5 13 13 21.5 2.5 11V2.5Z"/><circle cx="7" cy="7" r="1.6" fill="currentColor" stroke="none"/></svg>' +
        c.label +
      '</span>' +
      '<span class="clz-disc__v">-' + money(amount) + '</span>';

    var totalRow = findTotalRow(root);
    if(totalRow && totalRow.parentNode){ totalRow.parentNode.insertBefore(row, totalRow); }
  }

  var busy = false;
  function refresh(){
    var drawer = document.getElementById('cart-drawer');
    var page = document.querySelector('.shopify-section--main-cart, #main-cart');
    if(!drawer && !page) return;
    if(busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        [drawer, page].forEach(function(root){
          if(!root) return;
          hideExtras(root);
          renderDiscount(root, cart);
        });
      })
      .catch(function(){})
      .then(function(){ busy = false; });
  }

  document.addEventListener('DOMContentLoaded', refresh);
  refresh();
  ['cart:refresh','cart:update','cart:change'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(refresh, 250); });
  });
  document.addEventListener('click', function(e){
    if(e.target.closest('[aria-controls="cart-drawer"]') || e.target.closest('[data-clz-addbtn]')){
      setTimeout(refresh, 450);
    }
  });
  var observed = false;
  setInterval(function(){
    var d = document.getElementById('cart-drawer');
    if(d && !observed){
      observed = true;
      new MutationObserver(function(){ setTimeout(refresh, 150); }).observe(d, { childList:true, subtree:true });
    }
  }, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-cart-offer"]) return;
  try {
    
(function(){
  var CFG = null;
  var BAR = null;
  var LAST = null;
  var IGNORE_UNTIL = 0;   /* set by Buy now - see the click handler */

  var BUY_SELECTOR = '.clz-pd__buynow, [data-clz-buy], [data-clz-buynow]';

  function cfg(){
    if(CFG) return CFG;
    var el = document.querySelector('.clz-co-cfg');
    CFG = {
      t1: parseInt((el && el.dataset.t1) || '2', 10),
      t1p: (el && el.dataset.t1p) || '10',
      t2: parseInt((el && el.dataset.t2) || '5', 10),
      t2p: (el && el.dataset.t2p) || '15',
      max: (el && el.dataset.max) || 'Max savings unlocked'
    };
    return CFG;
  }

  function skeleton(){
    var c = cfg();
    return '' +
      '<div class="clz-co__in">' +
        '<div class="clz-co__top">' +
          '<span class="clz-co__pill" data-pill hidden></span>' +
          '<p class="clz-co__msg" data-msg></p>' +
        '</div>' +
        '<div class="clz-co__bar"><span class="clz-co__fill" data-fill style="width:0%"></span></div>' +
        '<div class="clz-co__ends">' +
          '<span class="clz-co__end" data-end1>' + c.t1 + ' \u00b7 ' + c.t1p + '%</span>' +
          '<span class="clz-co__end" data-end2>' + c.t2 + ' \u00b7 ' + c.t2p + '%</span>' +
        '</div>' +
      '</div>';
  }

  function topAlign(){
    var drawer = document.getElementById('cart-drawer');
    if(!drawer || !BAR || !BAR.isConnected) return;
    var node = BAR.assignedSlot || BAR;
    var guard = 0;
    while(node && guard++ < 6){
      var p = node.parentNode;
      if(!p) break;
      if(p.nodeType === 11){ p = p.host; if(!p) break; }
      if(p.nodeType !== 1) break;
      var d = getComputedStyle(p).display;
      if(d === 'flex' || d === 'inline-flex'){
        p.style.setProperty('justify-content','flex-start','important');
        p.style.setProperty('row-gap','0','important');
      } else if(d === 'grid' || d === 'inline-grid'){
        p.style.setProperty('align-content','start','important');
        p.style.setProperty('row-gap','0','important');
      }
      if(p !== drawer) p.style.setProperty('padding-top','0','important');
      if(p === drawer) break;
      node = p;
    }
  }

  function buildBar(){
    if(BAR) return BAR;
    BAR = document.createElement('div');
    BAR.className = 'clz-co';
    BAR.setAttribute('data-clz-cart-offer','');
    BAR.innerHTML = skeleton();
    return BAR;
  }

  function attach(){
    var drawer = document.getElementById('cart-drawer');
    if(!drawer) return null;
    var bar = buildBar();
    if(bar.parentNode !== drawer){
      var header = drawer.querySelector('header, .drawer__header, .cart-drawer__header');
      var anchor = header;
      while(anchor && anchor.parentNode && anchor.parentNode !== drawer){ anchor = anchor.parentNode; }
      if(anchor && anchor.parentNode === drawer){ drawer.insertBefore(bar, anchor.nextSibling); }
      else { drawer.insertBefore(bar, drawer.firstChild); }
      topAlign();
    }
    return bar;
  }

  function mount(){
    var nodes = [];
    var bar = attach();
    if(bar) nodes.push(bar);
    document.querySelectorAll('[data-clz-cart-offer]').forEach(function(n){
      if(nodes.indexOf(n) === -1) nodes.push(n);
    });
    nodes.forEach(function(n){
      if(!n.querySelector('[data-fill]')) n.innerHTML = skeleton();
      n.hidden = false;
    });
    topAlign();
    return nodes;
  }

  function paint(count){
    if(count === LAST){ mount(); return; }
    LAST = count;

    var c = cfg();
    var p1 = count >= c.t1, p2 = count >= c.t2;

    var pct = 0;
    if(p2){ pct = 100; }
    else if(p1){ pct = 50 + ((count - c.t1) / (c.t2 - c.t1)) * 50; }
    else { pct = (count / c.t1) * 50; }
    if(pct > 100) pct = 100;
    if(pct < 0) pct = 0;

    var pillText = p2 ? ('\u2713 ' + c.t2p + '%') : p1 ? ('\u2713 ' + c.t1p + '%') : '';

    var msg;
    if(p2){
      msg = '<strong class="clz-co__hi">' + c.max + '</strong>';
    } else if(p1){
      var n2 = c.t2 - count;
      msg = 'Add <strong>' + n2 + ' more</strong> for <strong class="clz-co__hi">' + c.t2p + '% off</strong>';
    } else {
      var n1 = c.t1 - count;
      msg = 'Add <strong>' + n1 + ' more</strong> for <strong class="clz-co__hi">' + c.t1p + '% off</strong>';
    }

    mount().forEach(function(n){
      var pill = n.querySelector('[data-pill]');
      var m    = n.querySelector('[data-msg]');
      var fill = n.querySelector('[data-fill]');
      var e1   = n.querySelector('[data-end1]');
      var e2   = n.querySelector('[data-end2]');
      if(!fill) return;
      if(pill){
        if(pillText){
          if(pill.textContent !== pillText) pill.textContent = pillText;
          pill.hidden = false;
        } else { pill.hidden = true; }
      }
      if(m && m.innerHTML !== msg) m.innerHTML = msg;
      fill.style.width = pct + '%';
      if(e1) e1.classList.toggle('is-on', p1);
      if(e2) e2.classList.toggle('is-on', p2);
      n.hidden = false;
    });

    topAlign();
  }

  function domCount(){
    var d = document.getElementById('cart-drawer');
    if(!d) return null;
    var inputs = d.querySelectorAll(
      'input[name="updates[]"], input.quantity__input, quantity-input input, ' +
      'input[type="number"][name*="quantity"], input[data-quantity-variant-id]'
    );
    if(!inputs.length) return null;
    var total = 0, seen = 0;
    for(var i = 0; i < inputs.length; i++){
      var v = parseInt(inputs[i].value, 10);
      if(!isNaN(v)){ total += v; seen++; }
    }
    return seen ? total : null;
  }

  function paintFromDom(){
    if(Date.now() < IGNORE_UNTIL) return;
    var c = domCount();
    if(c !== null) paint(c);
  }

  var busy = false, queued = false;
  function refresh(){
    if(Date.now() < IGNORE_UNTIL) return;
    if(busy){ queued = true; return; }
    busy = true;
    fetch('/cart.js', { headers: { 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){ paint(cart.item_count || 0); })
      .catch(function(){})
      .then(function(){
        busy = false;
        if(queued){ queued = false; setTimeout(refresh, 60); }
      });
  }

  var timer = null;
  function schedule(delay){
    clearTimeout(timer);
    timer = setTimeout(refresh, delay || 120);
  }

  document.addEventListener('DOMContentLoaded', function(){ schedule(0); });
  schedule(0);

  ['cart:refresh','cart:update','cart:change'].forEach(function(ev){
    document.addEventListener(ev, function(){ paintFromDom(); schedule(120); });
  });

  ['input','change'].forEach(function(ev){
    document.addEventListener(ev, function(e){
      var t = e.target;
      if(t && t.closest && t.closest('#cart-drawer')){
        paintFromDom();
        schedule(150);
      }
    }, true);
  });

  document.addEventListener('click', function(e){
    /* Buy now is a checkout action, not a cart action. Whatever the payment
       provider does to the cart while its modal is open must not move this bar.
       Ignore everything briefly, then let the next real cart event correct it. */
    if(e.target.closest(BUY_SELECTOR)){
      IGNORE_UNTIL = Date.now() + 8000;
      return;
    }

    /* Opening the drawer always reconciles against the real cart, so the bar
       can never sit on a stale count while the shopper is looking at it. */
    if(e.target.closest('[aria-controls="cart-drawer"]')){
      IGNORE_UNTIL = 0;
      schedule(0);
      return;
    }

    if(e.target.closest('[data-clz-addbtn]')){ IGNORE_UNTIL = 0; schedule(250); }

    if(e.target.closest('#cart-drawer button') || e.target.closest('#cart-drawer a')){
      requestAnimationFrame(paintFromDom);
      setTimeout(paintFromDom, 60);
      schedule(200);
    }
  });

  new MutationObserver(function(records){
    if(BAR && !BAR.isConnected){ attach(); }
    if(Date.now() < IGNORE_UNTIL) return;
    for(var i = 0; i < records.length; i++){
      var t = records[i].target;
      if(t && t.nodeType === 1 && t.closest && t.closest('#cart-drawer')){
        topAlign();
        paintFromDom();
        schedule(200);
        return;
      }
    }
  }).observe(document.documentElement, { childList:true, subtree:true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  var loading = false;

  function loadNext(){
    var wrap = document.querySelector('[data-clz-cmore]');
    var grid = document.querySelector('[data-clz-cgrid]');
    if(!wrap || !grid || loading) return;
    var url = wrap.getAttribute('data-next');
    if(!url) return;

    loading = true;
    wrap.classList.add('is-loading');

    fetch(url, { headers: { 'Accept':'text/html' } })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-clz-ccard]').forEach(function(card){
          /* appended cards are always below the fold */
          var im = card.querySelector('img');
          if(im) im.setAttribute('loading','lazy');
          grid.appendChild(document.importNode(card, true));
        });
        var nextWrap = doc.querySelector('[data-clz-cmore]');
        var nextUrl = nextWrap ? nextWrap.getAttribute('data-next') : '';
        if(nextUrl){ wrap.setAttribute('data-next', nextUrl); } else { wrap.remove(); }
      })
      .catch(function(){})
      .then(function(){
        loading = false;
        var w = document.querySelector('[data-clz-cmore]');
        if(w) w.classList.remove('is-loading');
        setTimeout(watch, 200);
      });
  }

  function watch(){
    var wrap = document.querySelector('[data-clz-cmore]');
    if(!wrap) return;
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ io.disconnect(); loadNext(); } });
      }, { rootMargin: '600px 0px' });
      io.observe(wrap);
    } else { loadNext(); }
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-clz-cmorebtn]')) loadNext();
  });

  if(document.readyState !== 'loading'){ watch(); }
  else { document.addEventListener('DOMContentLoaded', watch); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-deadstock-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  var IDLE = 'Select size to claim \u2192';
  var READY = 'Claim now \u2192';

  function openDrawer(){
    var t = document.querySelector('.header__cart-link a[aria-controls="cart-drawer"]') || document.querySelector('[aria-controls="cart-drawer"]');
    if(t) t.click();
  }
  function notify(){
    ['cart:refresh','cart:update','cart:change'].forEach(function(ev){ document.dispatchEvent(new CustomEvent(ev, { bubbles:true })); });
    var dot = document.querySelector('cart-count'); if(dot) dot.removeAttribute('hidden');
  }

  document.addEventListener('click', function(e){
    var sz = e.target.closest('[data-clz-dv]');
    if(sz && !sz.disabled){
      var card = sz.closest('[data-clz-dcard]');
      card.querySelectorAll('[data-clz-dv]').forEach(function(b){ b.classList.remove('is-on'); });
      sz.classList.add('is-on');
      card.dataset.selected = sz.getAttribute('data-clz-dv');
      var btn = card.querySelector('[data-clz-dclaim]');
      if(btn){ btn.textContent = READY; btn.classList.add('is-ready'); btn.classList.remove('is-err'); }
      return;
    }

    var claim = e.target.closest('[data-clz-dclaim]');
    if(claim && !claim.disabled){
      var c = claim.closest('[data-clz-dcard]');
      var id = c.dataset.selected || claim.getAttribute('data-single');
      if(!id){
        claim.textContent = 'Pick a size first';
        claim.classList.add('is-err');
        setTimeout(function(){ claim.textContent = IDLE; claim.classList.remove('is-err'); }, 1800);
        return;
      }
      claim.disabled = true;
      claim.textContent = 'Claiming\u2026';
      fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items:[{ id: Number(id), quantity: 1 }] })
      })
      .then(function(r){ if(!r.ok) throw new Error('fail'); return r.json(); })
      .then(function(){
        notify();
        claim.textContent = 'Claimed \u2713';
        setTimeout(function(){
          openDrawer();
          claim.disabled = false;
          claim.textContent = c.dataset.selected ? READY : IDLE;
        }, 320);
      })
      .catch(function(){
        claim.disabled = false;
        claim.textContent = 'Try again';
        setTimeout(function(){ claim.textContent = IDLE; }, 1800);
      });
      return;
    }

    if(e.target.closest('[data-clz-dmorebtn]')){ loadNext(); }
  });

  var loading = false;
  function loadNext(){
    var wrap = document.querySelector('[data-clz-dmore]');
    var grid = document.querySelector('[data-clz-dgrid]');
    if(!wrap || !grid || loading) return;
    var url = wrap.getAttribute('data-next');
    if(!url) return;
    loading = true;
    wrap.classList.add('is-loading');
    fetch(url, { headers: { 'Accept':'text/html' } })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-clz-dcard]').forEach(function(card){ grid.appendChild(document.importNode(card, true)); });
        var nextWrap = doc.querySelector('[data-clz-dmore]');
        var nextUrl = nextWrap ? nextWrap.getAttribute('data-next') : '';
        if(nextUrl){ wrap.setAttribute('data-next', nextUrl); } else { wrap.remove(); }
      })
      .catch(function(){})
      .then(function(){
        loading = false;
        var w = document.querySelector('[data-clz-dmore]');
        if(w) w.classList.remove('is-loading');
        setTimeout(watch, 200);
      });
  }

  function watch(){
    var wrap = document.querySelector('[data-clz-dmore]');
    if(!wrap) return;
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ io.disconnect(); loadNext(); } });
      }, { rootMargin: '600px 0px' });
      io.observe(wrap);
    } else { loadNext(); }
  }

  if(document.readyState !== 'loading'){ watch(); } else { document.addEventListener('DOMContentLoaded', watch); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-deadstock-hero"]) return;
  try {
    
(function(){
  var box = document.querySelector('[data-clz-ds-timer]');
  if(!box) return;
  var hours = parseInt(box.getAttribute('data-hours') || '48', 10);
  var total = hours * 3600 * 1000;
  var KEY = 'clz_ds_deadline_v2';
  var dl = parseInt(localStorage.getItem(KEY) || '0', 10);
  if(!dl || isNaN(dl) || dl < Date.now()){
    dl = Date.now() + total;
    try { localStorage.setItem(KEY, String(dl)); } catch(e){}
  }
  var h = box.querySelector('[data-h]'), m = box.querySelector('[data-m]'), s = box.querySelector('[data-s]');
  var prog = box.querySelector('[data-prog]');
  function pad(n){ return n < 10 ? '0' + n : String(n); }
  function tick(){
    var left = dl - Date.now();
    if(left < 0) left = 0;
    if(h) h.textContent = pad(Math.floor(left / 3600000));
    if(m) m.textContent = pad(Math.floor((left % 3600000) / 60000));
    if(s) s.textContent = pad(Math.floor((left % 60000) / 1000));
    if(prog) prog.style.width = ((left / total) * 100) + '%';
  }
  tick();
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-deadstock"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-clz-countdown]').forEach(function(el){
  var hours = parseInt(el.dataset.hours || '48', 10);
  var key = 'clz_ds_start';
  var start = localStorage.getItem(key);
  if(!start){ start = Date.now(); localStorage.setItem(key, start); }
  start = parseInt(start, 10);
  var end = start + hours*3600*1000;
  var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
  function pad(n){ return n < 10 ? '0'+n : ''+n; }
  function tick(){
    var left = end - Date.now();
    if(left <= 0){ left = 0; }
    var tot = Math.floor(left/1000);
    h.textContent = pad(Math.floor(tot/3600));
    m.textContent = pad(Math.floor((tot%3600)/60));
    s.textContent = pad(tot%60);
  }
  tick(); setInterval(tick, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-header-tweaks"]) return;
  try {
    
(function(){
  function clzHeaderCoins(){
    var nav = document.querySelector('.header__secondary-nav > ul');
    if(!nav || nav.querySelector('.clz-coins-link')) return;
    var cfg = document.querySelector('.clz-hdr-tweaks');
    var url = (cfg && cfg.dataset.coinsUrl) || '/pages/clazz-coins';
    var label = (cfg && cfg.dataset.coinsLabel) || 'Clazz Coins';
    var li = document.createElement('li');
    li.className = 'clz-coins-link';
    li.innerHTML = '<a href="' + url + '" class="block tap-area"><span class="sr-only">' + label + '</span><span class="clz-coin" aria-hidden="true">C</span></a>';
    var cart = nav.querySelector('.header__cart-link');
    if(cart){ nav.insertBefore(li, cart); } else { nav.appendChild(li); }
  }

  function drawer(){ return document.getElementById('menu-drawer'); }

  function addLabel(d){
    if(!d || d.querySelector('.clz-dw-label')) return;
    var cfg = document.querySelector('.clz-hdr-tweaks');
    var text = (cfg && cfg.dataset.drawerLabel) || 'Shop by category';
    var list = d.querySelector('ul');
    if(!list || !list.parentNode) return;
    var p = document.createElement('p');
    p.className = 'clz-dw-label';
    p.textContent = text;
    list.parentNode.insertBefore(p, list);
  }

  function set(el, props){
    for(var k in props){ el.style.setProperty(k, props[k], 'important'); }
  }

  /* Stretch's own rules outrank stylesheet overrides here, so write
     the values straight onto the elements. */
  function styleDrawer(){
    var d = drawer();
    if(!d) return;
    addLabel(d);

    d.querySelectorAll('a, summary').forEach(function(el){
      var nested = !!el.closest('details') && el.tagName !== 'SUMMARY';
      var size = nested ? '12.5px' : '15px';
      var weight = nested ? '500' : '700';
      var colour = nested ? 'rgba(245,245,243,.72)' : '#F5F5F3';
      var padLeft = nested ? '34px' : '20px';

      set(el, {
        'display':'flex',
        'align-items':'center',
        'justify-content':'space-between',
        'gap':'12px',
        'width':'100%',
        'padding-top':'15px',
        'padding-bottom':'15px',
        'padding-left':padLeft,
        'padding-right':'20px',
        'margin':'0',
        'border':'0',
        'border-bottom':'1px solid rgba(255,255,255,.08)',
        'border-radius':'0',
        'background':'transparent',
        'font-family':'var(--clz-body)',
        'font-size':size,
        'font-weight':weight,
        'letter-spacing':'.05em',
        'line-height':'1.25',
        'text-transform':'uppercase',
        'text-decoration':'none',
        'color':colour
      });

      el.querySelectorAll('*').forEach(function(c){
        if(c.tagName === 'SVG' || c.tagName === 'svg' || c.closest('svg')) return;
        set(c, {
          'font-size':size,
          'font-weight':weight,
          'letter-spacing':'.05em',
          'line-height':'1.25',
          'text-transform':'uppercase'
        });
      });

      var svg = el.querySelector('svg');
      if(svg){
        set(svg, {
          'width':'15px',
          'height':'15px',
          'flex':'none',
          'color':'rgba(255,255,255,.45)',
          'transform': el.tagName === 'SUMMARY' ? 'rotate(90deg)' : 'rotate(90deg)'
        });
      }
    });

    d.querySelectorAll('details[open] > summary svg').forEach(function(svg){
      set(svg, { 'transform':'rotate(-90deg)' });
    });
  }

  function init(){ clzHeaderCoins(); styleDrawer(); }

  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);

  document.addEventListener('click', function(e){
    if(e.target.closest('[aria-controls="menu-drawer"]')){
      setTimeout(styleDrawer, 40);
      setTimeout(styleDrawer, 220);
    }
    if(e.target.closest('#menu-drawer summary')){ setTimeout(styleDrawer, 60); }
  });

  var watched = false;
  setInterval(function(){
    var d = drawer();
    if(d && !watched){
      watched = true;
      new MutationObserver(function(){ setTimeout(styleDrawer, 60); }).observe(d, { childList:true, subtree:true });
      styleDrawer();
    }
  }, 900);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-mobile-menu"]) return;
  try {
    
(function(){
  function panel(){ return document.getElementById('clz-mm'); }

  function open(){
    var m = panel();
    if(!m) return;
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function close(){
    var m = panel();
    if(!m) return;
    m.hidden = true;
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[aria-controls="menu-drawer"]');
    if(trigger){
      e.preventDefault();
      e.stopPropagation();
      open();
      return;
    }
    if(e.target.closest('[data-clz-mmclose]')){ close(); return; }

    var toggle = e.target.closest('[data-clz-mmtoggle]');
    if(toggle){
      e.preventDefault();
      var group = toggle.closest('.clz-mm__group');
      var wasOpen = group.classList.contains('is-open');
      panel().querySelectorAll('.clz-mm__group').forEach(function(g){ g.classList.remove('is-open'); });
      if(!wasOpen) group.classList.add('is-open');
      return;
    }

    if(e.target.closest('.clz-mm__panel a')){ close(); }
  }, true);

  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-pincode"]) return;
  try {
    
(function(){
  function cfg(){
    var el = document.querySelector('.clz-pin-cfg');
    if(!el) return null;
    return {
      bd: (el.dataset.bd || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean),
      bdName: el.dataset.bdName || 'Bluedart Express Air',
      bdMin: parseInt(el.dataset.bdMin, 10) || 2,
      bdMax: parseInt(el.dataset.bdMax, 10) || 3,
      stdName: el.dataset.stdName || 'Express delivery',
      stdMin: parseInt(el.dataset.stdMin, 10) || 4,
      stdMax: parseInt(el.dataset.stdMax, 10) || 6,
      cutoff: parseInt(el.dataset.cutoff, 10) || 14
    };
  }

  /* a prefix entry can be "110" or a range "400-421" */
  function servedByBluedart(pin, list){
    for(var i = 0; i < list.length; i++){
      var entry = list[i];
      if(entry.indexOf('-') > -1){
        var parts = entry.split('-');
        var from = parts[0].trim(), to = parts[1].trim();
        var len = from.length;
        var head = parseInt(pin.slice(0, len), 10);
        if(head >= parseInt(from, 10) && head <= parseInt(to, 10)) return true;
      } else if(pin.indexOf(entry) === 0){
        return true;
      }
    }
    return false;
  }

  function addBusinessDays(days){
    var d = new Date();
    var added = 0;
    while(added < days){
      d.setDate(d.getDate() + 1);
      if(d.getDay() !== 0){ added++; }   /* Sundays are not delivery days */
    }
    return d;
  }

  function fmt(d){
    try { return d.toLocaleDateString('en-IN', { weekday:'short', day:'numeric', month:'short' }); }
    catch(e){ return d.toDateString(); }
  }

  function render(pin){
    var c = cfg();
    var out = document.querySelector('[data-clz-pinout]');
    if(!c || !out) return;

    if(!/^[1-9][0-9]{5}$/.test(pin)){
      out.className = 'clz-pd__pinout is-err';
      out.textContent = 'Enter a valid 6-digit pincode.';
      out.hidden = false;
      return;
    }

    var isBD = servedByBluedart(pin, c.bd);
    var minD = isBD ? c.bdMin : c.stdMin;
    var maxD = isBD ? c.bdMax : c.stdMax;

    /* orders placed after cut-off ship the next working day */
    var late = new Date().getHours() >= c.cutoff;
    if(late){ minD += 1; maxD += 1; }

    var from = addBusinessDays(minD);
    var to   = addBusinessDays(maxD);

    out.className = 'clz-pd__pinout clz-pin-res' + (isBD ? ' is-air' : '');
    out.innerHTML =
      '<span class="clz-pin-res__row">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
          (isBD
            ? '<path d="M2.5 13.5 21 4l-5 17-4.5-6.5L6 13Z"/>'
            : '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/>') +
        '</svg>' +
        '<b>' + (isBD ? c.bdName : c.stdName) + '</b>' +
      '</span>' +
      '<span class="clz-pin-res__eta">Delivers to <b>' + pin + '</b> between <b>' + fmt(from) + '</b> and <b>' + fmt(to) + '</b></span>' +
      (late ? '<span class="clz-pin-res__note">Ordered after today\u2019s cut-off \u2014 ships next working day</span>' : '');
    out.hidden = false;
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-clz-pincheck]');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var input = document.querySelector('[data-clz-pin]');
    render(((input && input.value) || '').replace(/\D/g, ''));
  }, true);

  document.addEventListener('keydown', function(e){
    if(e.key !== 'Enter') return;
    if(!e.target.matches('[data-clz-pin]')) return;
    e.preventDefault();
    render((e.target.value || '').replace(/\D/g, ''));
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-product-main"]) return;
  try {
    
(function(){
  if(!document.querySelector('.clz-pd')) return;
  function showTab(key){
    var wrap = document.getElementById('clz-tabs');
    if(!wrap) return;
    wrap.querySelectorAll('[data-clz-tab]').forEach(function(x){ x.classList.toggle('is-on', x.getAttribute('data-clz-tab') === key); });
    wrap.querySelectorAll('[data-clz-panel]').forEach(function(p){ p.classList.toggle('is-on', p.getAttribute('data-clz-panel') === key); });
  }
  function sgOpen(){ var d = document.getElementById('clz-sgd'); if(d){ d.hidden = false; document.documentElement.style.overflow = 'hidden'; } }
  function sgClose(){ var d = document.getElementById('clz-sgd'); if(d){ d.hidden = true; document.documentElement.style.overflow = ''; } }
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-clz-sgopen]')){ sgOpen(); return; }
    if(e.target.closest('[data-clz-sgclose]')){ sgClose(); return; }
    var th = e.target.closest('[data-clz-img]');
    if(th){
      var main = document.getElementById('clz-pd-main');
      if(main){ main.src = th.getAttribute('data-clz-img'); }
      document.querySelectorAll('.clz-pd__th').forEach(function(b){ b.classList.remove('is-on'); });
      if(th.classList.contains('clz-pd__th')) th.classList.add('is-on');
      return;
    }
    var tb = e.target.closest('[data-clz-tab]');
    if(tb){ showTab(tb.getAttribute('data-clz-tab')); return; }
    var sz = e.target.closest('[data-clz-v]');
    if(sz){
      document.querySelectorAll('[data-clz-v]').forEach(function(b){ b.classList.remove('is-on'); });
      sz.classList.add('is-on');
      var vid = document.querySelector('[data-clz-vid]');
      if(vid) vid.value = sz.getAttribute('data-clz-v');
      var now = document.querySelector('[data-clz-now]');
      var was = document.querySelector('[data-clz-was]');
      var off = document.querySelector('[data-clz-off]');
      var stock = document.querySelector('[data-clz-stock]');
      var stockT = document.querySelector('[data-clz-stocktext]');
      var add = document.querySelector('[data-clz-addbtn]');
      if(now) now.textContent = sz.getAttribute('data-price');
      if(was){
        if(sz.getAttribute('data-hascompare') === '1'){ was.textContent = sz.getAttribute('data-compare'); was.hidden = false; }
        else { was.hidden = true; }
      }
      if(off){
        var o = parseInt(sz.getAttribute('data-off'), 10);
        if(o > 0){ off.textContent = o + '% OFF'; off.hidden = false; } else { off.hidden = true; }
      }
      var avail = sz.getAttribute('data-avail') === '1';
      if(stock) stock.classList.toggle('is-out', !avail);
      if(stockT) stockT.textContent = avail ? 'In stock' : 'Sold out';
      if(add){ add.disabled = !avail; add.textContent = avail ? 'Add to bag' : 'Sold out'; }
      return;
    }
    var q = e.target.closest('[data-clz-q]');
    if(q){
      var input = document.querySelector('[data-clz-qty]');
      var n = parseInt(input.value || '1', 10);
      n = q.getAttribute('data-clz-q') === '+' ? n + 1 : Math.max(1, n - 1);
      input.value = n;
      return;
    }
    var sv = e.target.closest('[data-clz-save]');
    if(sv){ sv.classList.toggle('is-on'); return; }
    var pc = e.target.closest('[data-clz-pincheck]');
    if(pc){
      var pin = document.querySelector('[data-clz-pin]');
      var out = document.querySelector('[data-clz-pinout]');
      var val = (pin.value || '').replace(/\D/g,'');
      if(val.length !== 6){ out.textContent = 'Enter a valid 6-digit pincode.'; out.hidden = false; out.classList.add('is-err'); return; }
      var a = new Date(); a.setDate(a.getDate() + 2);
      var b = new Date(); b.setDate(b.getDate() + 4);
      var f = { day:'numeric', month:'short' };
      out.classList.remove('is-err');
      out.textContent = 'Delivers to ' + val + ' between ' + a.toLocaleDateString('en-IN', f) + ' and ' + b.toLocaleDateString('en-IN', f) + '.';
      out.hidden = false;
    }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ sgClose(); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-product-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  var b = e.target.closest('[data-clz-tab]');
  if(!b) return;
  var key = b.getAttribute('data-clz-tab');
  var wrap = b.closest('.clz-tabs');
  wrap.querySelectorAll('[data-clz-tab]').forEach(function(x){ x.classList.toggle('is-on', x === b); });
  wrap.querySelectorAll('[data-clz-panel]').forEach(function(p){ p.classList.toggle('is-on', p.getAttribute('data-clz-panel') === key); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-reel-pause"]) return;
  try {
    
(function(){
  function isMobile(){ return window.matchMedia('(max-width: 899px)').matches; }

  /* ---------------- swipeable product gallery ---------------- */
  function buildGallery(){
    if(!isMobile()) return;
    var gal = document.querySelector('.clz-pd__gal');
    if(!gal || gal.dataset.clzSlider === '1') return;

    var thumbs = gal.querySelectorAll('.clz-pd__th');
    var srcs = [];
    thumbs.forEach(function(t){
      var s = t.getAttribute('data-clz-img');
      if(s) srcs.push(s);
    });

    if(srcs.length < 2){
      var solo = document.getElementById('clz-pd-main');
      if(solo && !srcs.length) return;
    }

    var top = gal.querySelector('.clz-pd__galtop');
    if(!top) return;

    var track = document.createElement('div');
    track.className = 'clz-pdslide';
    srcs.forEach(function(s, i){
      var cell = document.createElement('div');
      cell.className = 'clz-pdslide__i';
      cell.innerHTML = '<img src="' + s + '" alt="" ' + (i === 0 ? '' : 'loading="lazy"') + '>';
      track.appendChild(cell);
    });

    var dots = document.createElement('div');
    dots.className = 'clz-pddots';
    srcs.forEach(function(_, i){
      var d = document.createElement('span');
      d.className = 'clz-pddot' + (i === 0 ? ' is-on' : '');
      d.setAttribute('data-i', i);
      dots.appendChild(d);
    });

    top.style.display = 'none';
    gal.insertBefore(track, top);
    gal.insertBefore(dots, top.nextSibling);
    gal.dataset.clzSlider = '1';

    var ticking = false;
    track.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.querySelectorAll('.clz-pddot').forEach(function(d, i){
          d.classList.toggle('is-on', i === idx);
        });
        gal.querySelectorAll('.clz-pd__th').forEach(function(t, i){
          t.classList.toggle('is-on', i === idx);
        });
        ticking = false;
      });
    }, { passive: true });

    function goTo(i){
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }
    dots.addEventListener('click', function(e){
      var d = e.target.closest('.clz-pddot');
      if(d) goTo(parseInt(d.getAttribute('data-i'), 10) || 0);
    });
    gal.querySelectorAll('.clz-pd__th').forEach(function(t, i){
      t.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        goTo(i);
      }, true);
    });
  }

  /* ---------------- reels ---------------- */
  function tileVideos(){ return document.querySelectorAll('.clz-reel video'); }
  function pauseTiles(){
    tileVideos().forEach(function(v){
      try { if(!v.paused){ v.dataset.clzWasPlaying = '1'; v.pause(); } } catch(e){}
    });
  }
  function resumeTiles(){
    tileVideos().forEach(function(v){
      try {
        if(v.dataset.clzWasPlaying === '1'){
          delete v.dataset.clzWasPlaying;
          var p = v.play();
          if(p && p.catch){ p.catch(function(){}); }
        }
      } catch(e){}
    });
  }
  function anyModalOpen(){ return !!document.querySelector('.clz-rm:not([hidden])'); }
  function killModalVideo(){
    if(!isMobile()) return;
    document.querySelectorAll('.clz-rm__v video').forEach(function(v){
      try { v.pause(); v.removeAttribute('autoplay'); v.currentTime = 0; } catch(e){}
    });
  }

  /* ---------------- sticky buy bar ---------------- */
  function realAdd(){ return document.querySelector('.clz-pd__form [data-clz-addbtn]'); }
  function realBuy(){ return document.querySelector('.clz-pd__form .clz-pd__buynow'); }

  function syncBar(){
    var bar = document.querySelector('.clz-sticky-atc');
    if(!bar) return;
    var a = realAdd();
    var pa = bar.querySelector('.clz-sticky-atc__add');
    if(a && pa){ pa.textContent = a.textContent; pa.disabled = a.disabled; }
  }

  function trackViewport(){
    var vv = window.visualViewport;
    if(!vv) return;
    function update(){
      var gap = Math.max(0, (window.innerHeight - vv.height - vv.offsetTop));
      document.documentElement.style.setProperty('--clz-vv-gap', gap + 'px');
    }
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    update();
  }

  function buildBar(){
    if(!document.querySelector('.clz-pd__form')) return;
    if(document.querySelector('.clz-sticky-atc')) return;
    var bar = document.createElement('div');
    bar.className = 'clz-sticky-atc';
    bar.innerHTML =
      '<button type="button" class="clz-sticky-atc__add">Add to bag</button>' +
      '<button type="button" class="clz-sticky-atc__buy">Buy it now</button>';
    document.body.appendChild(bar);
    syncBar();
    trackViewport();
    var a = realAdd();
    if(a && 'MutationObserver' in window){
      new MutationObserver(syncBar).observe(a, {
        childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled']
      });
    }
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('.clz-sticky-atc__add')){
      e.preventDefault();
      var a = realAdd();
      if(a && !a.disabled) a.click();
      return;
    }
    if(e.target.closest('.clz-sticky-atc__buy')){
      e.preventDefault();
      var b = realBuy();
      if(b) b.click();
      return;
    }
    if(e.target.closest('[data-clz-open]')){
      setTimeout(function(){ pauseTiles(); killModalVideo(); }, 20);
      return;
    }
    if(e.target.closest('[data-clz-close]')){
      setTimeout(function(){ if(!anyModalOpen()) resumeTiles(); }, 60);
    }
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ setTimeout(function(){ if(!anyModalOpen()) resumeTiles(); }, 60); }
  });
  document.addEventListener('visibilitychange', function(){
    if(document.hidden){ pauseTiles(); }
    else if(!anyModalOpen()){ resumeTiles(); }
  });

  function init(){ buildGallery(); buildBar(); }
  if(document.readyState !== 'loading'){ init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-reels"] && !Shopify.designMode) return;
  try {
    
(function(){

  /* A video only starts downloading once we ask it to. */
  function primeVideo(v){
    if(!v) return;
    v.muted = true;
    if(v.preload !== 'auto') v.preload = 'auto';
    var p = v.play();
    if(p && p.catch) p.catch(function(){});
  }
  function stopVideo(v){
    if(!v) return;
    try { v.pause(); } catch(e){}
  }

  function watchTiles(){
    var tiles = document.querySelectorAll('.clz-reel video');
    if(!tiles.length) return;

    if(!('IntersectionObserver' in window)){
      tiles.forEach(primeVideo);
      return;
    }

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting) primeVideo(en.target);
        else stopVideo(en.target);
      });
    }, { rootMargin: '150px 0px', threshold: 0.35 });

    tiles.forEach(function(v){ io.observe(v); });
  }

  if(document.readyState !== 'loading'){ watchTiles(); }
  else { document.addEventListener('DOMContentLoaded', watchTiles); }

  function openModal(id){
    var m = document.getElementById('clz-rm-' + id);
    if(!m) return;
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    primeVideo(m.querySelector('video'));
  }
  function closeModal(m){
    if(!m) return;
    m.hidden = true;
    document.documentElement.style.overflow = '';
    stopVideo(m.querySelector('video'));
  }
  function addToCart(id){
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: Number(id), quantity: 1 }] })
    }).then(function(r){ if(!r.ok){ throw new Error('add failed'); } return r.json(); });
  }
  document.addEventListener('click', function(e){
    var opener = e.target.closest('[data-clz-open]');
    if(opener){ e.preventDefault(); openModal(opener.getAttribute('data-clz-open')); return; }
    if(e.target.closest('[data-clz-close]')){ closeModal(e.target.closest('.clz-rm')); return; }

    var sz = e.target.closest('[data-clz-variant]');
    if(sz && !sz.disabled){
      var card = sz.closest('[data-clz-card]');
      card.querySelectorAll('[data-clz-variant]').forEach(function(b){ b.classList.remove('is-on'); });
      sz.classList.add('is-on');
      card.dataset.selected = sz.getAttribute('data-clz-variant');
      var btn = card.querySelector('[data-clz-add]');
      btn.textContent = 'Add to bag \u00b7 ' + (btn.getAttribute('data-price') || '');
      btn.classList.remove('is-err');
      return;
    }

    var buy = e.target.closest('[data-clz-buy]');
    if(buy){
      var bc = buy.closest('[data-clz-card]');
      var bid = bc.dataset.selected;
      if(!bid){ var ab = bc.querySelector('[data-clz-add]'); ab.textContent = 'Pick a size first'; ab.classList.add('is-err'); return; }
      buy.disabled = true; buy.textContent = 'Taking you there\u2026';
      addToCart(bid).then(function(){ window.location.href = '/checkout'; })
        .catch(function(){ buy.disabled = false; buy.textContent = 'Try again'; });
      return;
    }

    var add = e.target.closest('[data-clz-add]');
    if(add){
      var c = add.closest('[data-clz-card]');
      var id = c.dataset.selected;
      if(!id){ add.textContent = 'Pick a size first'; add.classList.add('is-err'); return; }
      add.disabled = true; add.textContent = 'Adding\u2026';
      addToCart(id).then(function(){
        add.textContent = 'Added \u2713'; add.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true }));
        var dot = document.querySelector('cart-count'); if(dot){ dot.removeAttribute('hidden'); }
        setTimeout(function(){ add.disabled = false; add.textContent = 'Add to bag'; add.classList.remove('is-done'); }, 2200);
      }).catch(function(){
        add.disabled = false; add.textContent = 'Try again'; add.classList.add('is-err');
      });
    }
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ document.querySelectorAll('.clz-rm:not([hidden])').forEach(closeModal); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-size-filter"]) return;
  try {
    
(function(){
  var wrap = document.querySelector('[data-clz-sf-fallback]');
  if(!wrap) return;
  var params = new URLSearchParams(window.location.search);
  var active = params.get('filter.v.option.size') || '';
  wrap.querySelectorAll('[data-size]').forEach(function(a){
    if((a.getAttribute('data-size') || '') === active){ a.classList.add('is-on'); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clz-ui-tweaks"]) return;
  try {
    
(function(){
  function inlineSizeChart(){
    var src = document.querySelector('.clz-sgd__body');
    var panel = document.querySelector('[data-clz-panel="fit"]');
    if(!src || !panel) return;
    if(panel.querySelector('.clz-sgc-inline')) return;
    var btn = panel.querySelector('.clz-pd__sgbtn');
    if(btn) btn.remove();
    var clone = src.cloneNode(true);
    clone.className = 'clz-sgc clz-sgc-inline';
    clone.removeAttribute('id');
    panel.appendChild(clone);
  }

  function addWhatsApp(){
    var form = document.querySelector('.clz-pd__form');
    if(!form || document.querySelector('.clz-wa-chat')) return;
    var cfg = document.querySelector('.clz-ui-tweaks');
    var url = (cfg && cfg.dataset.wa) || '';
    var text = (cfg && cfg.dataset.waText) || 'Questions? Chat with our team';
    if(!url) return;
    var a = document.createElement('a');
    a.className = 'clz-wa-chat';
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M12 3.2a8.8 8.8 0 0 0-7.5 13.4L3.2 20.8l4.4-1.3A8.8 8.8 0 1 0 12 3.2Z"/>' +
        '<path d="M9.4 8.4c.2-.4.4-.4.6-.4h.5c.2 0 .4 0 .6.5l.7 1.6c.1.2 0 .4-.1.5l-.4.5c-.1.2-.2.3 0 .6a7 7 0 0 0 2.8 2.3c.3.1.4 0 .6-.1l.5-.6c.2-.2.3-.1.5 0l1.5.8c.2.1.3.2.3.3 0 .3-.1.9-.4 1.2-.3.3-1 .6-1.6.6-1.4 0-3.2-1-4.5-2.2a10 10 0 0 1-2-3c-.3-.9-.2-1.9.3-2.6Z" class="clz-wa-chat__fill"/>' +
      '</svg>' +
      '<span>' + text + '</span>';
    form.parentNode.insertBefore(a, form.nextSibling);
  }

  /* drop the intro paragraph on product rails only */
  function stripRailBody(){
    document.querySelectorAll('.clz-sec').forEach(function(sec){
      if(!sec.querySelector('.clz-rail')) return;
      var body = sec.querySelector('.clz-body');
      if(body) body.remove();
    });
  }

  function init(){ inlineSizeChart(); addWhatsApp(); stripRailBody(); }
  if(document.readyState !== 'loading'){ init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  setTimeout(init, 600);
})();

  } catch(e) { console.error(e); }
})();
})();
